import cookieClass from "./cookieClass";
import axios from 'axios';

export default class userCookie extends cookieClass {

  private admin = false;

  public userId = null;

  public premium = false;
  
  public hasInfo = false;

  constructor(name: string) {
    super(name)
  }

  public async setValues(user) {
    if (user) {
      if (this.value)
        this.userId = this.value.user_id
      await this.setAdmin()
    }
  }

  public isAdmin() {
    return this.admin;
  }

  public isEditor() {
    return this.value && this.value.role && this.value.role === 'editorX';
  }

  public async setAdmin() {
    let userIdToFetch: string | null = null;

    // First, try to get user_id from the cookie's value object
    if (this.value && this.value.user_id) {
      userIdToFetch = this.value.user_id;
    }

    // If not found in the cookie's value, try to get it from URL query parameters.
    // This covers cases where this.value exists but this.value.user_id is missing,
    // or if this.value.user_id was present but falsy.
    if (!userIdToFetch) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const userIdFromQuery = urlParams.get('user_id');
        if (userIdFromQuery) { // Check if a value was actually retrieved
          userIdToFetch = userIdFromQuery;
        }
      } catch (e) {
        // Log error if URLSearchParams is not available or window.location.search fails.
        // This might happen in non-browser environments.
        console.warn("Could not parse URL query parameters for admin check:", e);
        // userIdToFetch will remain null if an error occurs here.
      }
    }

    // If a userId was successfully determined (from cookie or query param)
    if (userIdToFetch) {
      try {
        const { data } = await axios.get(`/admin/${userIdToFetch}`);
        this.admin = data; // Expect data to be a boolean

      } catch (error) {
        console.error(`Failed to fetch admin status for user ID ${userIdToFetch}:`, error);
        this.admin = false; // Default to not admin on error
      }
    } else {
      // If no userId could be determined from any source, user is not admin.
      this.admin = false;
    }
  }


}
